<div class="snack-container">
  <div class="icon">
    <mat-icon>{{getIcon}}</mat-icon>
  </div>
  <div class="message">
    <span>{{data.message}}</span>
  </div>
  @if (data.action) {
    <div class="action">
      <button matButton="filled" (click)="snackBarRef.dismiss()">{{data.action}}</button>
    </div>
  }

  @if (data.refresh) {
    <div class="action">
      <button matIconButton (click)="snackBarRef.dismissWithAction()">
        <mat-icon class="material-icons-outlined">refresh</mat-icon>
      </button>
    </div>
  }
</div>